<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="شكر-وتقدير">
<h1><span dir="rtl">شكر وتقدير</span></h1>
<p style="text-align: center;"><span dir="rtl">أتوجَّه بالشكر أولًا إلى الله جلَّ جلاله بأنه مَنَّ بهذا الفتح لتحقيق المَنفعة للإنسانية</span><br/>
<span dir="rtl">ثمَّ أتوجَّه بالشكر إلى كلِّ مَن ساهَم ولو بالدعاء..</span> <span dir="rtl">والحمد لله ربِّ العالمين.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?0d378eb2